//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {EncryptionEvent} from '../../../types/encryption-events';
import {BehaviorSubject, Observable} from 'rxjs';
import {EncryptionEventService} from '../../../services/encryption-event.service';
import { SortAttr } from '../../../types/common';

export class EncryptionEventDataSource extends DataSource<EncryptionEvent> {
    private encryptionEvents: EncryptionEvent[] = [];
    public loading: boolean = false;
    public count: number = null;

    private encryptionEvents$: BehaviorSubject<EncryptionEvent[]> = new BehaviorSubject<EncryptionEvent[]>([]);

    constructor(private readonly encryptionEventService: EncryptionEventService, private readonly pageSize: number) {
        super();
    }

    connect(collectionViewer: CollectionViewer): Observable<EncryptionEvent[]> {
        return this.encryptionEvents$.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer) {
        this.encryptionEvents$.complete();
    }

    fetch(selectedOrgId: string, searchText = '', events: string[] = [], scopes: string[] = [],
          sortAttrs: [SortAttr] = [{ 'sortAttr': 'dttm', 'sortOrder': 'desc' }]) {
        this.loading = true;
        this.encryptionEvents = []
        this.encryptionEvents$.next(this.encryptionEvents);
        this.encryptionEventService.getEncryptionEvents(selectedOrgId, this.pageSize, null, searchText, events,
            sortAttrs, scopes)
        .subscribe(response => {
            this.encryptionEvents = response.events;
            this.count = response.count;
            this.loading = false;
            this.encryptionEvents$.next(this.encryptionEvents);
        });
    }

    extend(selectedOrgId: string, searchText = '', events: string[] = [], scopes: string[] = [],
           sortAttrs: [SortAttr] = [{ 'sortAttr': 'dttm', 'sortOrder': 'desc' }]) {
        const offset = this.encryptionEvents.length;
        this.loading = true;
        this.encryptionEventService.getEncryptionEvents(selectedOrgId, this.pageSize, offset, searchText, events,
            sortAttrs, scopes).subscribe(response => {
            this.encryptionEvents = [...this.encryptionEvents, ...response.events];
            this.count = response.count;
            this.loading = false;
            this.encryptionEvents$.next(this.encryptionEvents);
        });
    }

    haveMoreData(): boolean {
        return this.count > this.encryptionEvents.length;
    }
}
